module.exports = __webpack_public_path__ + "static/media/ic_arrow_down.a12526c7.svg";